(function() {
    'use strict';

    angular.module('remitEventsApp').controller('MenuController', function($location, $scope, $translate, ContractorFilter) {
        var vm = this;

        $scope.$on('contractorsSet', function(event, contractors) {
            vm.contractors = contractors;
        });

        vm.contractors = ContractorFilter.getGlobalContractors();

        vm.isActive = function(match, suffix) {
            var isActive = false;

            if (_.isArray(match)) {
                for (var i = 0; i < match.length; i++) {
                    var url = suffix ? match[i] + suffix : match[i];
                    isActive = isActive ? isActive : $location.url().indexOf(url) !== -1;
                }

                return isActive;
            }

            return $location.url().indexOf(match) !== -1;
        };

        vm.getPressOfficeLink = function(type) {
            var language = $translate.use();
            var link = '';

            switch (type) {
                case 'gas':
                    link =
                        language === 'pl'
                            ? 'pl/o-firmie/media/komunikaty-prasowe-kategorie/energetyka'
                            : 'en/about-the-company/media/press-releases-categories/power-generation';
                    break;
                case 'energy':
                    link =
                        language === 'pl'
                            ? 'pl/o-firmie/media/komunikaty-prasowe-kategorie/energetyka'
                            : 'en/about-the-company/media/press-releases-categories/power-generation';
                    break;
            }

            return 'http://www.orlen.pl/' + link;
        };
    });
})();
